import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';
import { CustomMultiSelect } from '@/core/components/MultiSelect';

export interface EnumMultiSelectControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;

  options: { value: string; label: string }[];
}

export function EnumMultiSelectControl<T extends FieldValues>(props: EnumMultiSelectControlProps<T>) {
  const { withAsterisk, label, placeholder, description, name, isSubmitting, isDisabled, options, control } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <CustomMultiSelect
      searchable
      data={options}
      ref={field.ref}
      name={field.name}
      value={field.value}
      onChange={field.onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      withAsterisk={withAsterisk}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      flex={1}
    />
  );
}
